<template>
  <div class="site-select">
    <div class="heading" @click="() => toggleDrop()">
      <img :src="iconSiege" alt="" />
      <div class="description">
        <b>{{ heading.title }}</b>
        <small>{{ heading.baseline }}</small>
      </div>
      <i v-if="ruleFilters && ruleFilters.length > 1" :class="opened ? 'icon-arrow_up' : 'icon-arrow_down'" />
    </div>
    <Transition name="dropdown">
      <div v-if="opened" class="actual-site-container">
        <div v-for="(item, idx) in ruleFilters" :key="idx" class="fieldset">
          <input :id="`actual-site-${idx}`" v-model="filter" type="checkbox" :value="item" />
          <label :for="`actual-site-${idx}`">
            <b>{{ item }}</b>
            <small>{{ getSiteFromName(item).address }}</small>
          </label>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import assetProvider from '@/pure/assetProvider';
import { useSignalR } from '@dreamonkey/vue-signalr';

export default {
  data() {
    const ruleFilters = this.$store.getters.ruleFilters ? this.$store.getters.ruleFilters.actualSite : null;
    return {
      ruleFilters: ruleFilters,
      opened: false,
    };
  },

  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
      filters: 'filters',
      study: 'study',
    }),

    iconSiege() {
      return assetProvider.iconSiege;
    },

    actualSiteFilter() {
      return this.filters && this.filters.actualSites && this.filters.actualSite.length === 0 && this.ruleFilters ? this.ruleFilters : this.filters.actualSite;
    },

    actualSiteFilterCount() {
      return this.actualSiteFilter.length;
    },

    actualSites() {
      if (this.study && this.study.sites) {
        return this.study.sites.filter(item => item.type === 'Actual');
      }
      return [];
    },

    heading() {
      const isNotAlone = this.ruleFilters && this.ruleFilters.length > 1 && this.actualSiteFilter.length !== 1;
      const site = this.ruleFilters && this.ruleFilters.length === 1 ? this.actualSites[0] : this.getSiteFromName(this.actualSiteFilter[0]);
      const title = isNotAlone
        ? this.ruleFilters.length !== this.actualSiteFilterCount && this.actualSiteFilterCount > 0
          ? this.$t('actualSite', this.actualSiteFilterCount, { count: this.actualSiteFilterCount })
          : this.$t('allCurrentSites')
        : site
          ? site.name
          : '';
      const baseline = isNotAlone || !site ? '' : site.address;
      return {
        title,
        baseline,
      };
    },

    filter: {
      get() {
        return this.filters.actualSite;
      },

      set(newVal) {
        this.groupFilter = !!(this.ruleFilters && newVal.length === this.ruleFilters.length);
        this.updateParams(newVal, 'actualSite');
      },
    },
  },

  created() {
    this.$socket = useSignalR();
  },

  methods: {
    getSiteFromName(name) {
      return this.actualSites.find(item => item.name === name);
    },

    updateParams(newVal, parameter) {
      this.$store.dispatch('updateFilters', {
        key: parameter,
        value: newVal,
      });
      if (!this.isDesktop || this.$route.name === 'Controller') {
        if (this.study && this.study.collaborators_total > 2000) {
          const id = this.study.id || this.$route.params.studyId;
          this.$store.dispatch('uploadRawData', { id: id, content: this.$store.getters.screen() }).then(result => {
            this.$socket.invoke('action', { action: 'tvBlob', parameters: result });
          });
        } else {
          this.$socket.invoke('action', { action: 'tvData', parameters: this.$store.getters.screen() });
        }
      }
    },

    toggleDrop() {
      if (this.ruleFilters && this.ruleFilters.length > 1) {
        this.opened = !this.opened;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
@use '@/styles/animations.scss';
.site-select {
  width: 260px;
  flex-shrink: 0;
  box-sizing: border-box;
  border-right: 1px solid #e3e3e3;
  height: 100%;
  .heading {
    position: relative;
    z-index: 1;
    height: 100%;
    padding-left: 16px;
    background-color: #f6f5f2;
    cursor: pointer;
    user-select: none;
    img {
      width: 23px;
      height: auto;
    }
    .description {
      color: #262631;
      padding-left: 8px;
      box-sizing: border-box;
      flex: 1;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      max-width: 194px;
      small {
        display: block;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    i {
      padding-right: 4px;
    }
  }
  .actual-site-container {
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    .fieldset {
      height: 54px;
      box-sizing: border-box;
      padding-left: 16px;
      display: flex;
      align-items: center;
      & + .fieldset {
        border-top: 1px solid #e3e3e3;
      }
      label {
        color: #262631;
        display: flex;
        justify-content: center;
        flex-direction: column;
        height: 26px;
        font-size: 14px;
        padding-left: 30px;
        margin-bottom: 0;
        flex: 1;
        overflow: hidden;
        box-sizing: border-box;
        padding-right: 0.5em;

        small {
          font-size: 12px;
          display: block;
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  [type='checkbox']:not(:checked) + label:after,
  [type='checkbox']:checked + label:after {
    margin-top: 6px;
  }
  [type='checkbox']:not(:checked) + label:before,
  [type='checkbox']:checked + label:before {
    margin-top: 6px;
  }
}
</style>
